import types from '../actionTypes';

export const showHistory = (history) => (dispatch, getState) => {

    dispatch({
        type: types.SHOW_HISTORY,
        payload: {history},
    });

};